import { formatBytes } from '../../config/file-size';
import { FileTextIcon, LinkIcon } from '../../layout/icons';
import { MediaOverlay } from '../link/MediaOverlay';
import { YoutubeOverlay } from '../link/YoutubeOverlay';
import { UploadOverlay } from '../upload/UploadOverlay';
import { googlePreviewUrl } from './submissions';
import type { SubmissionOverlayState } from './useSubmissionViewer';

export interface SubmissionOverlayProps {
  overlay: SubmissionOverlayState | null;
  onClose: () => void;
}

// a submission item the board cannot paint as a page: a video, a recording, a share link or an office file
export function SubmissionOverlay({ overlay, onClose }: SubmissionOverlayProps) {
  if (!overlay) return null;
  if (overlay.kind === 'youtube') return <YoutubeOverlay video={overlay.video} onClose={onClose} />;
  if (overlay.kind === 'file' && overlay.viewer !== 'file') return <UploadOverlay file={overlay.file} viewer={overlay.viewer} onClose={onClose} />;
  if (overlay.kind === 'file') {
    return (
      <MediaOverlay title={overlay.file.name} fit="card" onClose={onClose}>
        <div className="upload-card">
          <div className="upload-card__head">
            <span className="upload-card__mark" aria-hidden={true}><FileTextIcon size={26} /></span>
            <span className="upload-card__meta"><strong>{overlay.file.name}</strong><span>{formatBytes(overlay.file.size)}</span></span>
          </div>
          <p className="upload-card__note">Bảng chưa xem trước được loại tệp này (Word, PowerPoint, tệp nén). Thầy/cô mở bài nộp trên IZTeach để xem.</p>
        </div>
      </MediaOverlay>
    );
  }
  const preview = googlePreviewUrl(overlay.url);
  if (preview) {
    return (
      <MediaOverlay title={overlay.title} onClose={onClose}>
        <div className="hw-link">
          <iframe className="hw-link__frame" src={preview} title={overlay.title} allow="autoplay; fullscreen" allowFullScreen={true} />
          <p className="hw-link__hint">Không xem được thì học sinh chưa chia sẻ tệp ở chế độ «Bất kỳ ai có đường liên kết».</p>
        </div>
      </MediaOverlay>
    );
  }
  return (
    <MediaOverlay title={overlay.title} fit="card" onClose={onClose}>
      <div className="upload-card">
        <div className="upload-card__head">
          <span className="upload-card__mark" aria-hidden={true}><LinkIcon size={26} /></span>
          <span className="upload-card__meta"><strong>Liên kết bài nộp</strong><span className="hw-link__url">{overlay.url}</span></span>
        </div>
        <p className="upload-card__note">Bảng chỉ mở sẵn được liên kết YouTube và Google Drive. Thầy/cô mở liên kết này trên máy tính để xem.</p>
      </div>
    </MediaOverlay>
  );
}
